<template>
    <CContainer>
        <h6>Seguimiento Garantía</h6> 
        <CCard
            class="mt-4 mb-1 p-3 col-sm-12">
            <CCardBody>
              <CForm class="p-2">
                  <CCol sm="4" class="d-inline-block">
                      <CSelect 
                          label="Tipo Contrato: "
                          addLabelClasses="text-muted font-weight-bold text-capitalize"
                          :value.sync="warrantyTrace.status"
                          :options="[
                            {value: 'RAD', label: 'Radicada'}, 
                            {value: 'PRE', label: 'Producto Recibido'}, 
                            {value: 'REV', label: 'Revision'}, 
                            {value: 'PRO', label: 'En Proceso'},
                            {value: 'PEN', label: 'Producto para Entrega'},
                            {value: 'FIN', label: 'Finalizada'},
                            {value: 'REC', label: 'Rechazada'},
                          ]"
                          @change="() => validate()"
                      />
                  </CCol>
                  <CCol sm="4" class="d-inline-block">
                    <CInput
                        label="Fecha:"
                        type="date"
                        addLabelClasses="text-muted font-weight-bold text-capitalize"
                        :value.sync="warrantyTrace.date"
                        @input="newValue => {
                            validate()
                        }"
                        :isValid="warrantyTrace.date.length > 0">
                    </CInput>
                  </CCol>
                  <CCol sm="12" class="d-inline-block">
                    <CTextarea
                        label="Observaciones: "
                        addLabelClasses="text-muted font-weight-bold text-capitalize"
                        :value.sync="warrantyTrace.observations"
                        :isValid="warrantyTrace.observations.length > 0"
                        @blur="() => {          
                            validate()
                        }"
                    />
                </CCol>
                  <CCol sm="12" class="d-inline-block">
                    <CInputFile
                      label="Archivo Adjunto:"
                      addLabelClasses="text-muted font-weight-bold text-capitalize"
                      addInputClasses="col-sm-12"
                      placeholder="Seleccione archivo..."
                      :horizontal="true" 
                      :custom="true"
                      @change="(files) => file2base64 = files"
                    >
                    <template #prepend-content>
                      <BCIcon name="paperclip"/>
                    </template>
                  </CInputFile>
                </CCol>
              </CForm>
            </CCardBody>
            <CCardFooter class="d-flex justify-content-center">
                <CButton
                    color="success"
                    class="mx-2"
                    @click="saveWarrantyTracing()"
                    :class="isValidForm ? '' : 'disabled'"
                    :disabled="!isValidForm">
                    <CIcon name="cil-check-alt"/>
                    <span class="align-middle mx-2">Guardar</span>
                </CButton>
                <CButton
                    color="danger"
                    variant="outline"
                    class="mr-2"
                    :to="rootPath">
                    <CIcon name="cil-x"/>
                    <span class="align-middle mx-2">Cancelar</span>
                </CButton>
            </CCardFooter>
        </CCard>
        <CElementCover  v-show="loading"/>
    </CContainer>
</template>

<script>
  import { ref } from "vue";
  import BCIcon from '../../containers/BCIcon'
  import { toBase64 } from '../../../general'
  import CONSTANTS from '../../../constants'
  import { grabaSeguimientoGarantia } from "@/api";

  export default {
  components: { BCIcon },
    data() {
      return {
        loading: false,
        isValidForm: false,
        warrantyId: "",
          warrantyTraceStatus: true,
          CONSTANTS,
          file2base64: [],
          warrantyTrace: {
            status: 'RAD',
            date: '',
            observations: '',
            fileName: '',
            fileBase64: ''
          },
          warrantyTraceIndex: "",
          assuredValue: 0,
          addRentedProductsModal: false
      }
    },
    methods: {
      toBase64,
      validate() {
          console.log(this.warrantyTrace.date)
        this.isValidForm = this.warrantyTrace.observations.length > 0 && (this.warrantyTrace.date.length > 0)
      },
      async saveWarrantyTracing() {
        this.loading = true

        try {
          this.warrantyTrace.fileName = this.fileExtension
          this.warrantyTrace.fileBase64 = await this.toBase64(this.file2base64).then(file => file)
          
          const {errorMessage} = await grabaSeguimientoGarantia(
            this,
            this.warrantyId,
            this.warrantyTrace.status,
            this.warrantyTrace.date,
            this.warrantyTrace.observations,
            this.warrantyTrace.fileName,
            this.warrantyTrace.fileBase64
          )
          this.$store.commit('setAlert', {
            color: "success",
            message: errorMessage,
            show: 5
          });

          this.$router.push({path: `${this.rootPath}`});
        } catch {
          this.$store.commit('setAlert', {
            color: "danger",
            message: CONSTANTS.messages.notDoneAdd,
            show: 5
          })
        } finally {
          this.loading = false;
        }
      },
    },
    computed: {
      // warrrantyId(){
      //   return this.$store.state.selectedWarranty.id_Garantia
      // },
      fileExtension(){
        if (this.file2base64[0]) {
            return this.file2base64[0].name
        } else {
            return ""
        }
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.warrantyId = this.$router.currentRoute.params.id;

      this.rootPath = this.rootPath.replace(`/${this.warrantyId}/seguimientos/agregar`, "");

      console.log(this.rootPath);
      console.log(this.warrantyId);
    }
  }
</script>
